/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

// auth.js
import globalPriceManager from '../utils/globalPriceManager';
import { STUDIO_INDICATOR_STATE_STORAGE_KEY } from '../utils/studioIndicatorStore';
import { SYMBOL_INFO_CACHE_STORAGE_KEY } from './symbolInfoCache';

const LOCAL_STORAGE_KEYS_TO_CLEAR = [
  'token',
  'refresh_token',
  'user',
  'tradeContext:accountId',
  'user:prefs',
  'app-style',
  'app-color-scheme',
  'app-bg-video',
  'paxia-platform-themes',
  'paxia-personal-themes',
  'paxia-theme-preference',
  'paxia-custom-styles',
  'paxia-custom-color-schemes',
  'ctrader_pending_internal_account_id',
  'ctrader_callback_temp_id',
  STUDIO_INDICATOR_STATE_STORAGE_KEY,
  SYMBOL_INFO_CACHE_STORAGE_KEY,
];

const SESSION_STORAGE_KEYS_TO_CLEAR = [
  'paxia:auth-bootstrap-until',
  'ctrader_pending_internal_account_id',
];

const COOKIE_KEYS_TO_CLEAR = [
  'ctrader_pending_internal_account_id',
];

const clearStorageKeys = (storage, keys) => {
  if (!storage) return;
  keys.forEach((key) => {
    try { storage.removeItem(key); } catch { /* ignore storage failures */ }
  });
};

const clearCookie = (name) => {
  try {
    document.cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax`;
  } catch { /* ignore cookie failures */ }
};

export const logoutUser = () => {
  // --- Close all WebSocket connections BEFORE removing the token ---
  // 1. globalPriceManager: watchlist per-symbol price sockets
  try { globalPriceManager.closeAll(); } catch { /* ignore teardown failures */ }

  // 2. Clear persisted auth and user-scoped UI state before notifying listeners.
  clearStorageKeys(localStorage, LOCAL_STORAGE_KEYS_TO_CLEAR);
  clearStorageKeys(sessionStorage, SESSION_STORAGE_KEYS_TO_CLEAR);
  COOKIE_KEYS_TO_CLEAR.forEach(clearCookie);

  // 3. Dispatch a 'paxia:logout' event so persistent providers can tear down
  //    sockets and reset in-memory state against an already-cleared storage layer.
  try { window.dispatchEvent(new Event('paxia:logout')); } catch { /* ignore event failures */ }
};
